<template>
  <div v-if="userRolesData" class="">
    <div class="table-container">
      <table class="my-table">
        <thead>
          <tr>
            <th>#</th>
            <th>{{ $t("name") }}</th>
            <th>{{ $t("description") }}</th>
            <th>{{ $t("notes") }}</th>
            <th>{{ $t("info") }}</th>
            <th>{{ $t("edit") }}</th>
            <th>{{ $t("delete") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(UserRole, index) in userRolesData" :key="index">
            <td>{{ ++index }}</td>
            <td>
              {{ isDataExist(UserRole.establishmentRoleNameCurrent) }}
            </td>
            <td>
              {{ isDataExist(UserRole.establishmentRoleDescriptionCurrent) }}
            </td>
            <td>{{ isDataExist(UserRole.establishmentRoleNotes) }}</td>
            <td>
              <button
                v-b-modal.UserRoleInfo
                class="btn p-0"
                :title="$t('info')"
                @click="setUserRoleData(UserRole)"
              >
                <img src="@/assets/images/info.svg" class="icon-lg" />
              </button>
            </td>
            <td>
              <router-link
                :to="`/settings/settings-other/edit-${userRoleData.userType}-role/${UserRole.establishmentRoleToken}`"
                :title="$t('edit')"
              >
                <img src="@/assets/images/pencil.svg" class="icon-lg" />
              </router-link>
            </td>
            <td>
              <button
                v-b-modal.UserRoleDelete
                class="btn p-0"
                :title="$t('delete')"
                @click="setUserRoleData(UserRole)"
              >
                <img src="@/assets/images/trash.svg" class="icon-lg" />
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { setDataMultiLang, timeToLang, isDataExist } from "@/utils/functions";

export default {
  name: "UserRolesTable",
  data() {
    return {
      language: localStorage.getItem("userLanguage") || "ar",
    };
  },
  props: ["userRolesData", "userRoleData"],
  methods: {
    setUserRoleData(userRoleData) {
      this.$emit("setUserRoleData", userRoleData);
    },
    timeToLang(time) {
      return timeToLang(time, this.language);
    },
    setDataMultiLang(lang, dataAr, dataEn, dataUnd) {
      return setDataMultiLang(lang, dataAr, dataEn, dataUnd);
    },
    isDataExist(data) {
      return isDataExist(data);
    },
  },
  computed: {},
  created() {},
};
</script>

<style lang="scss"></style>
